const state = () => {
  return {
    login: {
      email: "",
      password: "",
      session: ""
    },
    register: {
      // eligibility
      birth_date: "",
      state: null,
      zip_code: "",
      county: "",
      city: "",
      program_code: "",

      // register
      first_name: "",
      last_name: "",
      email: "",
      confirm_email: "",
      phone: "",
      confirm_phone: "",
      password: "",
      confirm_password: "",
      preferred_contact_method: "",

      // other info
      address_line_1: "",
      address_line_2: "",

      race: "",
      gender: "",
      is_hispanic: false,

      mailing_address_1:"",
      mailing_address_2:"",
      mailing_city:"",
      mailing_state:"",
      mailing_zipcode:"",
      mailing_county:"",
      physical_or_mailing_address:"",
      who_do_you_have_sex_with:"",
      sex_assgined_at_birth:"",
      physical_zip_code:"",
      physical_state:null,
      sex_at_birth:"",
      physical_state_name:"",
    },
    reset_password: {
      email: "",
      token: "",
      new_password: "",
      confirm_password: ""
    }
  };
};

export default state;
